import _map from 'lodash/map';

export const getBundleSkusAndPrice = (skus, storeProductData) => {
  const bundleSkusAndPrices = _map(skus, (sku) => ({
    sku,
    basePrice: storeProductData?.[sku]?.pricing?.value || 0
  }));

  return bundleSkusAndPrices;
};
